module.exports = __webpack_public_path__ + "img/golden-days.56f30dc0.png";